import React, { useContext, createContext, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import ReactHtmlParser from 'react-html-parser';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
    useHistory,
    useLocation
} from "react-router-dom";

import { ProvideAuth, useAuth } from './BD21Auth';
import { App } from './App'
import './Login.css'

//import { uiSubtitle, uiTitle } from './system-configuration'
import '@radnuc/react-ui-components/dist/StatusHeader.css';

const API_ROOT = window.app && window.app.env.API_URL;

const Title: React.FC<{ title: string }> = (props) => {
    return (
        <label className="Title">{props.title}</label>
    )
}
const Subtitle: React.FC<{ subtitle: string }> = (props) => {
    return (
        <label className="Subtitle">{props.subtitle}</label>
    )
}

export default function AuthApp() {
    return (
        <ProvideAuth>
            <Router>
                <Switch>
                    <Route path="/login">
                        <LoginPage />
                    </Route>
                    <Route path="/new-pass">
                        <ChangePasswordPage />
                    </Route>
                    <Route path="/mfa">
                        <MFAPage />
                    </Route>
                    <PrivateRoute exact path="/">
                        <App />
                    </PrivateRoute>
                    <Redirect from="*" to="/" />
                </Switch>
            </Router>
        </ProvideAuth>
    );
}

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
function PrivateRoute({ children, ...rest }: any) {
    let auth = useAuth();
    return (
        <Route
            {...rest}
            render={({ location }) =>
                auth?.jwtToken ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
}

function LoginPage() {
    let history = useHistory();
    let location = useLocation();
    let auth = useAuth();

    const [user, setUser] = useState("");
    const [password, setPassword] = useState("");
    const [loginMessage, setLoginMessage] = useState("");

    function validateForm() {
        return user.length > 0 && password.length > 0;
    }

    function handleSubmit(event: any) {
        console.log(auth);
        auth?.signin((currentStatus: string, data?:Object) => {
            console.log('currentStatus: '+currentStatus)
            if (currentStatus==='NEWPASS')
                history.replace({ pathname: "/new-pass" });
            else if (currentStatus==='MFA_REQUIRED'){
                history.replace({ pathname: "/mfa" });
                window.sessionStorage.setItem('cred1', btoa(user));
                window.sessionStorage.setItem('cred2', btoa(password));
                if(data){
                    if((data as any).session){
                        window.sessionStorage.setItem('session', (data as any).session);
                    }
                    if((data as any).parameters){
                        window.sessionStorage.setItem('message', JSON.stringify((data as any).parameters));
                    }
                }

            } else if (currentStatus==='AUTHENTICATED'){
                history.replace({ pathname: "/" });

                //Store in sessionStorage
                window.sessionStorage.setItem('cred1', btoa(user));
                window.sessionStorage.setItem('cred2', btoa(password));
            } else if (currentStatus === 'ERROR'){
                console.log('ERROR ')
                if(data){
                    const err = (data as any).err;
                    const err_string = err.toString();
                    console.log(err_string)
                    if(err_string.includes('UserNotFoundException')){
                        setLoginMessage('Incorrect User or Password');
                    } else if(err_string.includes('NotAuthorizedException')){
                        setLoginMessage('Incorrect User or Password');
                    } else {
                        setLoginMessage('Login Error');
                    }
                }
                const timeoutTimer = setTimeout(() => {
                    setLoginMessage('');
                    history.replace({ pathname: "/login" });
                }, 4000);
            } else {
                //NOT HANDLED
                history.replace({ pathname: "/login" });
            }
        }, user, password);
        event.preventDefault();
    }

    let titleDisplay;
    const uiTitle = API_ROOT.LoginTitle;
    const uiSubtitle = API_ROOT.LoginSubtitle;
    if(uiTitle !== undefined){
        titleDisplay = <Title title={uiTitle} />;
    }
    let subtitleDisplay;
    if(uiSubtitle !== undefined){
        subtitleDisplay = <Subtitle subtitle={uiSubtitle}/>
    }

    let headerDisplay =
        <div style={{display: 'flex', flexDirection: 'column'}}>
            {titleDisplay}
            {subtitleDisplay}
        </div>
    let termsAndConditionsDisplay;
    if(API_ROOT.TermsAndConditions){
        if(API_ROOT.TermsAndConditions.Show){
            termsAndConditionsDisplay =
                <div style={{display:'flex',justifyContent:'center',justifySelf:'anchor-center',paddingTop:'10%'}}>
                    <div style={{display:'inline',justifyContent:'center',alignSelf:'center',width:'60%', minWidth:'450px', fontSize:'8px',textAlign:'justify'}}>
                    {ReactHtmlParser(TermsOfUseHTMLString)}
                    <br/><br/>
                    {ReactHtmlParser(AgreementToRecSMSHTMLString)}
                    <br/><br/>
                    {ReactHtmlParser(PrivacyHTMLString)}
                    </div>
                </div>
        }
    }
    return (
        <>
        <div style={{display:'flex',justifyContent:'center',padding:'20px'}}>
            <div className="header-left" style={{display: 'flex', flexDirection: 'row', height: '65px'}}>
            <div className="logo"></div>
                {headerDisplay}
            </div>
        </div>
        <div className="Login">
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="username">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                        size="lg"
                        autoFocus
                        type="username"
                        value={user}
                        onChange={(e) => setUser(e.target.value)}
                        placeholder="Username"
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="password">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        size="lg"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                    />
                </Form.Group>
                <Button block size="lg" type="submit" disabled={!validateForm()}>
                    Login
                </Button>
            </Form>
            <div style={{display:'flex',justifyContent:'center',padding:'0px',minHeight:'30px'}}>
                <i>{loginMessage}</i>
            </div>
            {termsAndConditionsDisplay}
        </div>

        </>
    );
}

function ChangePasswordPage() {
    let history = useHistory();
    let location = useLocation();
    let auth = useAuth();

    const [user, setUser] = useState("");
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [passwordOk, setPasswordOk] = useState(false);
    const [repeatPasswordOk, setRepeatPasswordOk] = useState(false);

    function containsUppercase(str:string) {
      return /[A-Z]/.test(str);
    }

    function containsLowercase(str:string) {
      return /[a-z]/.test(str);
    }

    function containsSpecialChars(str:string) {
      return /[^a-zA-Z0-9]/.test(str);
    }

    function validateForm() {
        //console.log(user+' '+name+' '+password+' '+repeatPassword)
        //return user.length > 0 && name.length > 0 && password.length > 0 && repeatPassword.length > 0 && password == repeatPassword;

        //Password Criteria
        const password_ok_flag = password.length > 7 && containsUppercase(password) && containsLowercase(password) && containsSpecialChars(password);
        const repeat_password_ok_flag = repeatPassword.length > 7 && containsUppercase(repeatPassword) && containsLowercase(repeatPassword) && containsSpecialChars(repeatPassword);

        console.log('password_ok_flag:'+password_ok_flag)
        if(!password_ok_flag){
            if(passwordOk){
                setPasswordOk(false);
            }
            if(passwordError !== 'Password must be at least 8 characters contain 1 uppercase, 1 lowercase, 1 special character'){
                setPasswordError('Password must be at least 8 characters contain 1 uppercase, 1 lowercase, 1 special character');
            }
        } else {
            if(!passwordOk){
                setPasswordOk(true);
            }
        }

        if(!repeat_password_ok_flag){
            if(repeatPasswordOk){
                setRepeatPasswordOk(false);
            }
            if(passwordError !== 'Password must be at least 8 characters contain 1 uppercase, 1 lowercase, 1 special character'){
                setPasswordError('Password must be at least 8 characters contain 1 uppercase, 1 lowercase, 1 special character');
            }
        } else {
            if(password !== repeatPassword){
                if(repeatPasswordOk){
                    setRepeatPasswordOk(false);
                }
                if(passwordError !== 'Passwords do not match'){
                    setPasswordError('Passwords do not match');
                }
            } else {
                if(!repeatPasswordOk){
                    setRepeatPasswordOk(true);
                }
            }
        }

        if(password_ok_flag && repeat_password_ok_flag && password === repeatPassword){
            if(passwordError !== ''){
                setPasswordError('');
            }
        }
        return name.length > 0 && password_ok_flag && repeat_password_ok_flag && password == repeatPassword;
    }

    function handleSubmit(event: any) {
        console.log(auth);
        auth?.changePassword((currentStatus: string, data?:Object) => {
            console.log('currentStatus: '+currentStatus)
            if (currentStatus==='MFA_REQUIRED'){
                history.replace({ pathname: "/mfa" });
                window.sessionStorage.setItem('cred1', btoa(user));
                window.sessionStorage.setItem('cred2', btoa(password));
                if(data){
                    if((data as any).session){
                        window.sessionStorage.setItem('session', (data as any).session);
                    }
                    if((data as any).parameters){
                        window.sessionStorage.setItem('message', JSON.stringify((data as any).parameters));
                    }
                }

            } else if (currentStatus==='AUTHENTICATED'){
                history.replace({ pathname: "/" });
            } else if (currentStatus === 'ERROR'){
                //console.log('Password change error ')
                if(data){
                    const err = (data as any).err;
                    const err_string = err.toString();
                    console.log(err_string)
                    setPasswordError(err_string);
                } else {
                    setPasswordError('Password Change Error');
                }
                const timeoutTimer = setTimeout(() => {
                    setPasswordError('');
                    history.replace({ pathname: "/login" });
                }, 4000);
            } else {
                //NOT HANDLED
                history.replace({ pathname: "/login" });
            }
        }, name, password);
        event.preventDefault();
    }

    let titleDisplay;
    const uiTitle = API_ROOT.LoginTitle;
    const uiSubtitle = API_ROOT.LoginSubtitle;
    if(uiTitle !== undefined){
        titleDisplay = <Title title={uiTitle} />;
    }
    let subtitleDisplay;
    if(uiSubtitle !== undefined){
        subtitleDisplay = <Subtitle subtitle={uiSubtitle}/>
    }

    let headerDisplay =
        <div style={{display: 'flex', flexDirection: 'column'}}>
            {titleDisplay}
            {subtitleDisplay}
        </div>
    return (
        <>
        <div style={{display:'flex',justifyContent:'center',padding:'20px'}}>
            <div className="header-left" style={{display: 'flex', flexDirection: 'row', height: '65px'}}>
            <div className="logo"></div>
                {headerDisplay}
            </div>
        </div>
        <div className="ChangePassword">
            <div style={{display:'flex',justifyContent:'center',padding:'0px'}}>
                <h3>You must change your password</h3>
            </div>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="user">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                        autoFocus
                        type="username"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3" controlId="password">
                    <Form.Label>New Password</Form.Label>
                    <div style={{display:'flex',flexDirection:'row', alignItems:'center',padding:'0px'}}>
                    <Form.Control
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {passwordOk?<div>{'\u2713'}</div>:<div>{'\u2717'}</div>}
                    </div>
                </Form.Group>
                <Form.Group className="mb-3" controlId="repeatPassword">
                    <Form.Label>Retype New Password</Form.Label>
                    <div style={{display:'flex',flexDirection:'row', alignItems:'center',padding:'0px'}}>
                    <Form.Control
                        type="password"
                        value={repeatPassword}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                    />
                    {repeatPasswordOk?<div>{'\u2713'}</div>:<div>{'\u2717'}</div>}
                    </div>
                </Form.Group>
                <Button block size="lg" type="submit" disabled={!validateForm()}>
                    Login
                </Button>
            </Form>
            <div style={{display:'flex',justifyContent:'center',padding:'0px'}}>
                <i>{passwordError}</i>
            </div>
        </div>
        </>
    );
}

function MFAPage() {
    let history = useHistory();
    let location = useLocation();
    let auth = useAuth();
    let message = window.sessionStorage.getItem('message');
    if(message !== null){
        const parameters = JSON.parse(message) as any
        message = parameters.CODE_DELIVERY_DELIVERY_MEDIUM+' message with code sent to '+parameters.CODE_DELIVERY_DESTINATION;
    }
    //const [user, setUser] = useState("");
    const [mfacode, setMfaCode] = useState("");
    const [mfaMessage, setMfaMessage] = useState(message);

    function validateForm() {
        return mfacode.length > 0;
    }

    function handleSubmit(event: any) {
        console.log(auth);
        const session = window.sessionStorage.getItem('session')
        if(session !== null)
        auth?.confirmMfa((currentStatus: string, data?:Object) => {
            console.log(currentStatus)
            if(currentStatus === 'AUTHENTICATED'){
                console.log('redir')
                history.replace({ pathname: "/" });
            } else {
                console.log(data)
                setMfaMessage('Invalid Code');
                const timeoutTimer = setTimeout(() => {
                    history.replace({ pathname: "/login" });
                }, 4000);
                //history.replace({ pathname: "/login" });
            }

                //Store in sessionStorage
                //window.sessionStorage.setItem('cred1', btoa(user));
                window.sessionStorage.setItem('cred3', btoa(mfacode));
        }, mfacode, session);
        event.preventDefault();
    }

    let titleDisplay;
    const uiTitle = API_ROOT.LoginTitle;
    const uiSubtitle = API_ROOT.LoginSubtitle;
    if(uiTitle !== undefined){
        titleDisplay = <Title title={uiTitle} />;
    }
    let subtitleDisplay;
    if(uiSubtitle !== undefined){
        subtitleDisplay = <Subtitle subtitle={uiSubtitle}/>
    }

    let headerDisplay =
        <div style={{display: 'flex', flexDirection: 'column'}}>
            {titleDisplay}
            {subtitleDisplay}
        </div>
    return (
        <>
        <div style={{display:'flex',justifyContent:'center',padding:'20px'}}>
            <div className="header-left" style={{display: 'flex', flexDirection: 'row', height: '65px'}}>
            <div className="logo"></div>
                {headerDisplay}
            </div>
        </div>
        <div className="Login">
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="mfacode">
                    <Form.Label>Verify Your Identity</Form.Label>
                    <Form.Control
                        size="lg"
                        autoFocus
                        type="mfacode"
                        value={mfacode}
                        onChange={(e) => setMfaCode(e.target.value)}
                        placeholder="Enter your Code"
                    />
                </Form.Group>
                <Button block size="lg" type="submit" disabled={!validateForm()}>
                    Continue
                </Button>
            </Form>
        </div>
        <div style={{display:'flex',justifyContent:'center',padding:'0px'}}>
            <i>{mfaMessage}</i>
        </div>
        </>
    );
}
const TermsOfUseHTMLString = '<b>Terms of Use</b> '+
'<i>Introduction</i> '+
'This Terms of Use Agreement (the \“Agreement\”) governs your use of the REACT COP located at '+API_ROOT.TermsAndConditions.HomeUrl+' (the \“Website\”). REACT is operated by Physical Sciences Inc. (the \“Company\”).\n'+
'By using REACT, you agree to be bound by this Agreement. If you do not agree to this Agreement, you may not use REACT.\n'+
'Definitions'+
'•	\“User Content\” means any content that you submit to the Website. '+
'•	\“Intellectual Property Rights\” means all intellectual property rights, including copyrights, trademarks, patents, and trade secrets. '+
'<i>Permitted Use</i>  '+
'You may use the Website for lawful purposes only. You may not use the Website to: '+
'•	Upload any content that is unlawful, harmful, threatening, abusive, harassing, tortuous, defamatory, vulgar, obscene, libelous, or otherwise objectionable. '+
'•	Impersonate any person or entity. '+
'•	Violate the intellectual property rights of any third party. '+
'•	Transmit any worms or viruses or any other code of a destructive nature. '+
'<i>Intellectual Property Rights</i> '+
'Some elements of REACT are protected by intellectual property laws. You agree to not infringe on the intellectual property rights of the Company or any third party. '+
'<i>Limitation of Liability</i> '+
'The Company is not liable for any damages that you may suffer as a result of using REACT. '+
'<i>Dispute Resolution</i> '+
'Any disputes arising out of or relating to this Agreement will be resolved by binding arbitration in accordance with the rules of the American Arbitration Association. '+
'<i>General</i> '+
'This Agreement constitutes the entire agreement between you and the Company regarding the use REACT. '+
'If any provision of this Agreement is held to be invalid or unenforceable, such provision will be struck from this Agreement and the remaining provisions will remain in full force and effect. '


const AgreementToRecSMSHTMLString = '<b>Agreement to Receive Text Messages </b>'+
'By providing your mobile number, you agree that PSI may send you periodic SMS messages containing MFA codes. '+
'You will receive up to 4 messages per month. '+
'You may unsubscribe at any time by texting the word STOP. You may receive a subsequent message confirming your opt-out request. '+
'For help, send the word HELP. '+
'Message and data rates may apply. '+
'You agree to notify us of any changes to your mobile number and update your account with us to reflect this change. '+
'Data obtained from you in connection with this SMS service may include your cell phone number, your carrier’s name, and the date, time and content of your messages, as well as other information that you provide. We may use this information to contact you and to provide the services you request from us. '+
'By subscribing or otherwise using the service, you acknowledge and agree that we will have the right to change and/or terminate the service at any time, with or without cause and/or advance notice. '+
'<i>Will I be charged for the text messages I receive?</i> '+
'Though PSI will never charge you for the text messages you receive, depending on your phone plan, you may see some charges from your mobile provider. Please reach out to your wireless provider if you have questions about your text or data plan. ';

const PrivacyHTMLString = '<b>Privacy Notice:</b> PSI respects your privacy and will only use the information you voluntarily provide to us through Web forms, emails, or other methods to determine the best match between your requirements and our solutions. We do not sell or give any of your information to any third-party or send you any unsolicited advertisements. ';
